import type { BoardObject, ImageObject } from '../interfaces/board-object.interface.js';
import type { ClipboardImagePlan } from './clipboard-image-plan.type.js';

/**
 * Decides whether a copy puts a picture on the system clipboard (ticket "bild kopieren
 * ermöglichen", Stefan's decisions of 2026-10-28).
 *
 * @param objects The objects being copied, already expanded by `expandForTransfer` — a selected
 *   group arrives together with its members, so a group holding one image counts as mixed.
 */
export function planClipboardImage(objects: ReadonlyArray<BoardObject>): ClipboardImagePlan {
  const images = objects.filter((o): o is ImageObject => o.type === 'image');
  if (images.length >= 2) {
    return { kind: 'marker-only', reason: 'multiple-images', imageCount: images.length };
  }
  if (objects.length === 1 && images.length === 1) {
    const image = images[0]!;
    const source = image.src ?? image.dataUrl;
    if (source) return { kind: 'image', image, source };
  }
  return { kind: 'marker-only', reason: null };
}
